<div class="container my-4">
  <div class="topheadtitle">
    <h4>eCitation Courts</h4>
  </div>

  <div class="saerch-section d-flex justify-content-between mb-2">
    <div class="row g-3 align-items-center">
      <div class="col-auto">
        <label for="court-filter" class="col-form-label">Filter</label>
      </div>
      <div class="col-auto">
        <input type="text" id="court-filter" class="form-control form-control-sm" placeholder="Search for any text"
          (input)="filterList($event)" />
        </div>
      </div>

      <div></div>

      @if (userType === 'S') {
        <div class="new-btn">
          <button class="btn btn-outline-secondary btn-sm" type="button" (click)="addEdit(content,'add',null);">
            New <i class="fa-sharp fa-solid fa-plus" aria-hidden="true"></i>
          </button>
        </div>
      }
    </div>

    <main class="table-container w-100">
      <table class="table" aria-describedby="courts-results-summary">
        <caption>eCitation list of all courts.</caption>
        <thead>
          <tr>
            <th scope="col">
              <button type="button" class="btn btn-link p-0 sort-header" aria-label="Sort by Court Name"
                (click)="onSort($event,'courtName',true)">
                Court Name <i class="fa fa-sort" aria-hidden="true"></i>
              </button>
            </th>
            <th scope="col">Court Number</th>
            <th scope="col">Vendor</th>
            <th scope="col">Status</th>
            @if (userType === 'S') {
              <th scope="col">Edit</th>
            }
          </tr>
        </thead>
        <tbody>
          @for (item of getItems(); track item) {
            <tr>
              <td>{{ item.courtName }}</td>
              <td>{{ item.courtNumber }}</td>
              <td>{{ item.vendorName }}</td>
              <td>{{ item.courtStatusDesc }}</td>
              @if (userType === 'S') {
                <td>
                  <button type="button" class="icon-button" [attr.aria-label]="'Edit ' + item.courtName"
                    (click)="addEdit(content,'edit',item)">
                    <i class="fa-sharp fa-solid fa-pen-to-square" aria-hidden="true"></i>
                    <span class="visually-hidden">Edit {{ item.courtName }}</span>
                  </button>
                </td>
              }
            </tr>
          }
        </tbody>
      </table>

      <div id="courts-results-summary" class="d-flex justify-content-between align-items-center" aria-live="polite">
        <div class="w-33">
          <span>{{ listAllCourtDetails.length }} items found, displaying {{ getCurrentPageTotal() }} of {{
          listAllCourtDetails.length }}</span>
        </div>

        <ngb-pagination [collectionSize]="listAllCourtDetails.length" [(page)]="currentPage" [ellipses]="true"
          [maxSize]="10" (pageChange)="onPageChange(currentPage)" [pageSize]="10" [boundaryLinks]="true"
        aria-label="Courts list pagination"></ngb-pagination>

        <div class="w-33"></div>
      </div>
    </main>
  </div>

  <!-- add new Court -->
  <ng-template class="modal-dialog modal-lg" #content let-modal>
    <div class="step-1" aria-modal="true" aria-labelledby="modal-basic-title">
      <div class="modal-header">
        <h4 style="font-size: 12px;" class="modal-title" id="modal-basic-title">
          {{ mode == 'add' ? 'Add New' : 'Edit' }} Court
        </h4>
        <button type="button" class="btn-close" aria-label="Close"
        (click)="modal.dismiss('Cross click');courtForm.reset()"></button>
      </div>

      <div class="modal-body">
        @if (alert) {
          <div class="alert alert-danger" role="alert" aria-live="assertive">
            {{ alert.message }}
          </div>
        }

        <div class="d-flex align-items-center justify-content-center">
          <form [formGroup]="courtForm" (ngSubmit)="addCourt()">
            <div>
              <div class="mb-2">
                <label for="courtName" class="form-label">Court Name</label><span class="c-red">*</span>
                <input id="courtName" formControlName="courtName" type="text" class="form-control"
                  placeholder="Municipal Court" autofocus />
                  <app-control-message [control]="getFormControl('courtName')"
                  [message]="{ required: 'Field is requried' }"></app-control-message>
                </div>

                <div class="mb-2">
                  <label for="courtNumber" class="form-label">Court Number</label><span class="c-red">*</span>
                  <input id="courtNumber" formControlName="courtNumber" type="text" (keypress)="onlyNumber($event)"
                    class="form-control" placeholder="12345678" maxlength="8" max="8" minlength="8" />
                    <app-control-message [control]="getFormControl('courtNumber')"
                    [message]="{ required: 'Field is requried', minlength: 'Minimum 8 digits are required ' }"></app-control-message>
                  </div>

                  <div class="mb-2">
                    <span class="form-label">Password</span>@if (mode !== 'edit') {
                    <span
                    class="c-red">*</span>
                  }
                  <div class="input-group">
                    @if (courtForm.get('apiPassword')?.value) {
                      <input id="apiPassword" type="text"
                        formControlName="apiPassword" class="form-control" placeholder="Please generate a password"
                        readonly />
                    }
                    <button class="btn btn-outline-secondary" type="button" placement="top"
                      triggers="mouseenter:mouseleave focusin:focusout"
                      ngbPopover="Warning - Make sure you copy the above password now. We don't store it and you will not be able to see it again."
                      (click)="generatePass()">
                      Generate Password
                    </button>
                  </div>
                  <app-control-message [control]="getFormControl('apiPassword')"
                  [message]="{ required: 'Field is requried' }"></app-control-message>
                </div>

                <div class="mb-2">
                  <label for="vendorName" class="form-label">Vendor Company</label><span class="c-red">*</span>
                  <select id="vendorName" formControlName="vendorName" class="form-select form-select-sm"
                    aria-label="Vendor Company">
                    <option value="" disabled>Please Select a Vendor Company</option>
                    @for (item of listAllVendors; track item) {
                      <option [value]="item.vendorName">
                        {{ item.vendorName }}
                      </option>
                    }
                  </select>
                  <app-control-message [control]="getFormControl('vendorName')"
                  [message]="{ required: 'Field is requried' }"></app-control-message>
                </div>

                <div class="mb-2">
                  <label for="courtStatusDesc" class="form-label">Status</label><span class="c-red">*</span>
                  <select id="courtStatusDesc" formControlName="courtStatusDesc" class="form-select form-select-sm"
                    aria-label="Status">
                    <option value="" disabled>Please Select a Status</option>
                    @for (item of listStatusCodes; track item) {
                      <option [value]="item.courtStatusDesc">
                        {{ item.courtStatusDesc }}
                      </option>
                    }
                  </select>
                  <app-control-message [control]="getFormControl('courtStatusDesc')"
                  [message]="{ required: 'Field is requried' }"></app-control-message>
                </div>
              </div>
              <div class="modal-footer">
                <button type="button" (click)="modal.close('Cross click')" class="btn btn-danger btn-sm me-2">Cancel</button>
                <button type="submit" [disabled]="!courtForm.dirty" class="btn btn-primary btn-sm">
                  {{ mode == 'add' ? 'Submit' : 'Update' }}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>

    </ng-template>
